module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NTYuOTU0IiBoZWlnaHQ9IjYzNS4zNTciIHZpZXdCb3g9IjAgMCA1NTYuOTU0IDYzNS4zNTciPgogIDxwYXRoIGlkPSLjg5HjgrlfMzc0MSIgZGF0YS1uYW1lPSLjg5HjgrkgMzc0MSIgZD0iTTUxNy4yMzIsMTUwNC45VjEwODAuNjI5bDU1Ni45NTQtMjExLjA5M1YxMjkzLjhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTE3LjIzMSAtODY5LjUzNykiIGZpbGw9InJlZCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/common/red_557.svg
// module id = My07
// module chunks = 0